export default "__VITE_ASSET__DUIlbY8v__";